import { Interval } from "luxon";
import { type ParsedPaymentDetails, RevenueType } from "./supplierAcquiringReportsTypes";

export function filterDataByMerchantAndAdyentId<T extends { merchant?: { id: number }; balanceAccount: string }>(
    data: T[] | undefined,
    filters: { merchantId?: string; adyentId?: string },
): T[] {
    if (!Array.isArray(data)) {
        return []
    }

    return data.filter((item) => {
        // if (filters.merchantId && filters.adyentId) {
        //     return item.merchant?.id.toString() === filters.merchantId && item.balanceAccount === filters.adyentId
        // }

        if (filters.merchantId) {
            return item.merchant?.id.toString() === filters.merchantId
        }

        // if (filters.adyentId) {
        //     return item.balanceAccount === filters.adyentId
        // }

        // If no filter is specified, return all elements
        return true
    })
}

export function classifyPaymentRevenue(payment: ParsedPaymentDetails, period: Interval): RevenueType {
    // Allow type to be overriden from payment row
    if (payment.type) return payment.type

    if (period.isAfter(payment.bookingDate) && payment.valueDate && period.isAfter(payment.valueDate)) {
        return RevenueType.PREVIOUS_REVENUE
    }

    if (period.isAfter(payment.bookingDate)) {
        //return RevenueType.DEFERRED_REVENUE
        // NOTE: We do not distinguish between deferred and normal revenue here
        return RevenueType.NORMAL_REVENUE
    }

    if (payment.valueDate === undefined || period.isBefore(payment.valueDate)) {
        return RevenueType.ACCRUED_REVENUE
    }

    return RevenueType.NORMAL_REVENUE
}
